import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_BOOKING_SAGA } from "../sagaTypes";
import { loaderAction, bookingFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getWeekBookingSagaAction } from "../sagaActions";
import { BOOKING_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_booking`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateBooking(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('booking_id', args.data.id);
        formData.append('date', args.data.date);
        formData.append('time', args.data.time);
        formData.append('type', args.data.type);
        formData.append('coach', args.data.coach);
        formData.append('establishment', currentEstablishment);
        formData.append('name', args.data.name);
        formData.append('max_users', args.data.max_users);
        formData.append('hide_users', args.data.hide_users);
        formData.append('bound_subscriptions', args.data.bound_subscriptions);
        formData.append('color', args.data.color);
        formData.append('remind_datetime', args.data.remind_datetime);
        formData.append('start_registration_date', args.data.start_registration_date);
        formData.append('start_registration_time', args.data.start_registration_time);
        formData.append('finish_registration_hours', args.data.finish_registration_hours);
        formData.append('hide_in_app', args.data.hide_in_app);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Получаем записи
            yield put(getWeekBookingSagaAction({
                establishment: currentEstablishment,
                date: args.data.date
            }));

            // Очищаем форму записи
            yield put(bookingFormAction(BOOKING_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateBooking() {
    yield takeLatest(UPDATE_BOOKING_SAGA, workerUpdateBooking);
}